import { BodyMediumRegular, H1Regular, H5Regular, YStack } from 'smoothie';

export const NoAccessYet = () => {
    return (
        <YStack
            alignItems="center"
            justifyContent="center"
            gap={20}
            marginTop="30vh"
        >
            <H1Regular>🛸</H1Regular>
            <H5Regular>Unrecognized Visitor</H5Regular>
            <BodyMediumRegular>
                Your authorization is not recognized and you cannot access this
                app as an visiting alien.
            </BodyMediumRegular>
        </YStack>
    );
};
